import { GQLLocale } from 'graphql-ts-types';

import { Locale } from 'common/enums/Locale';
import { useScript } from 'common/hooks/use-script';
import { useLocalization } from 'common/providers/LocaleProvider';

export const useLoadAppleClient = (onLoad: () => void) => {
  const { locale } = useLocalization();

  const localeMap = {
    [Locale.De_At]: GQLLocale.DeDe,
    [Locale.De_Ch]: GQLLocale.DeDe,
    [Locale.De_De_H24]: GQLLocale.DeDe,
    [Locale.Fr_Be]: GQLLocale.FrFr,
    [Locale.Fr_Ch]: GQLLocale.FrFr,
    [Locale.Fr_Fr]: GQLLocale.FrFr,
    [Locale.It_It]: GQLLocale.ItIt,
    [Locale.Nl_Be]: GQLLocale.NlNl,
    [Locale.Nl_Nl]: GQLLocale.NlNl,
  };

  const APPLE_CLIENT_SCRIPT_SRC = `https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/${localeMap[locale]}/appleid.auth.js`;

  useScript({
    url: APPLE_CLIENT_SCRIPT_SRC,
    async: true,
    defer: true,
    onLoad,
  });
};
